exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll[data-v-0f929f37]{position:relative;z-index:100;overflow:hidden}\n", ""]);
